import api from './api';

export const requirementService = {
  async getFormData() {
    const response = await api.get('/requirements/form-data');
    return response.data;
  },

  async getRequirements(params = {}) {
    const response = await api.get('/requirements', { params });
    return response.data;
  },

  async getPendingRequirements() {
    const response = await api.get('/requirements/pending');
    return response.data;
  },

  async getRequirement(id) {
    const response = await api.get(`/requirements/${id}`);
    return response.data;
  },

  async createRequirement(data) {
    const response = await api.post('/requirements', data);
    return response.data;
  },

  async updateRequirement(id, data) {
    const response = await api.put(`/requirements/${id}`, data);
    return response.data;
  },

  async toggleStatus(id) {
    const response = await api.delete(`/requirements/${id}`);
    return response.data;
  },
};
